import { image_importer } from '../../../../helper/helper_functions';
import { useTranslation } from 'react-i18next';
import { useUserContext } from '../../../../hooks/useUserContext';
import './singleCard.css';

export default function SingleCard({ card, handleChoice, flipped, disabled }) {
    const {t} = useTranslation();
    const {language} = useUserContext();
    const cover = image_importer(require.context('../../../../assets/games/schutzrechte/sucht', false, /\.(png|jpe?g|svg)$/));
    let cover_src = "";
    switch (language) {
      case "de":
        cover_src = cover["cover.png"];
        break;
      case "fr":
        cover_src = cover["cover_fr.png"];
        break;
      case "it":
        cover_src = cover["cover_it.png"];
        break;
    };

    const handleClick = () => {
        if (!disabled) {
          handleChoice(card);
        };
    }

    const height = window.innerHeight;
    const width = window.innerWidth;
    const imgHeight = height * 0.5 / 3;
    const imgWidth = width * 0.5 / 4;
    const size = Math.min(imgHeight, imgWidth);

  return (
    <div className="card">
        <div className={flipped ? "flipped" : ""}>
            <img className="front" src={card.src} alt="card front" style={{height: size, width: size}} />
            <img className="back" src={cover_src} onClick={handleClick} alt="card back" style={{height: size, width: size}} />
        </div>
    </div>
  )
};